import React from 'react';

import { flagStyles } from '../settings';

const SvgPG = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-4176px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgPG;
